import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { ethers } from 'ethers'
import { getChainSymbol, MiningPoolAbi } from '../../../../utils/config'
import { useTranslation } from 'react-i18next'
import { getSelectedWalletEthersProvider } from '../../../../utils/selectedWalletProvider'
import ConsoleDialog from '../../../StakingConsole/ConsoleDialog'
import { mapStakingError } from '../../../StakingConsole/errorMessages'
import { buildInviteConfigPlan } from '../../transactionPlan'
import { waitForTransaction } from '../../../StakingConsole/transactionFeedback'

export default function InviteConfirmModal(props) {
    const [rate, setRate] = useState([''])
    const [submitLoading, setSubmitLoading] = useState(false)
    const [errorMsg, setErrorMsg] = useState('')
    const chainId = useSelector((state) => state.chainId)
    const { t } = useTranslation()
    useEffect(() => {
        setRate(props.invitorRewardPercentList?.length
            ? props.invitorRewardPercentList.map((item) => `${item}`)
            : [''])
    }, [props.invitorRewardPercentList])

    const submit = async () => {
        setErrorMsg('')
        const nextRate = rate
        if (!nextRate.length) return setErrorMsg(t('请设置推广算力'))
        let total = 0
        for (let index = 0; index < nextRate.length; index += 1) {
            const value = nextRate[index]
            if (!value) return setErrorMsg(t('请设置1级推广算力').replace('{index}', index + 1))
            if (parseFloat(value) < 0 || parseFloat(value) > 100) return setErrorMsg(t('1级推广算力应在0-100之间').replace('{index}', index + 1))
            total += parseFloat(value)
        }
        if (total > 100) return setErrorMsg(t('推广算力总和不能超过100%'))
        const percentBasisPoints = nextRate.map((value) => ethers.utils.parseUnits(`${value}`, 2))
        setSubmitLoading(true)
        try {
            const contract = new ethers.Contract(props.poolAddress, MiningPoolAbi, getSelectedWalletEthersProvider().getSigner())
            const plan = buildInviteConfigPlan({ rates: percentBasisPoints, isOpen: props.open, fee: props.fee })
            const tx = await contract[plan.method](...plan.args)
            const result = await waitForTransaction(tx)
            props.ok && props.ok({
                ...result,
                title: props.open ? t('推广设置更新成功') : t('邀请推广开启成功'),
                description: t('邀请推广配置已经链上确认。'),
            })
        } catch (error) { setErrorMsg(mapStakingError(error, t)) }
        setSubmitLoading(false)
    }
    const totalRate = rate.reduce((total, item) => total + (Number.parseFloat(item) || 0), 0)
    const formatRate = (value) => Number.isInteger(value) ? `${value}` : value.toFixed(2).replace(/0+$/, '').replace(/\.$/, '')
    const footer = <>
        <div className="console-invite-fee">
            <span>{props.open ? t('当前配置') : t('费用')}</span>
            <strong>{props.open ? t('已开启') : `${props.fee} ${getChainSymbol(chainId)}`}</strong>
        </div>
        <button type="button" className="console-button console-button--primary" disabled={submitLoading} onClick={submit}>{submitLoading ? t('处理中...') : t('提交')}</button>
    </>
    return <ConsoleDialog show={props.show} onClose={props.handleClose} closeLabel={t('关闭')} title={props.open ? t('设置推广算力等级') : t('开启推广邀请')} description={t('设置推广算力, 根据下级质押代币的数量, 提升上级的算力, 最高可实现7代推广')} icon="fa-users" className="console-invite-dialog" bodyClassName="console-invite-dialog__body" footer={footer}>
        <div className="console-invite-summary">
            <div>
                <i className="fa fa-route" aria-hidden="true" />
                <p>{t('例如: 1级算力5% 下级质押了1000个代币 那么上级将会获取1000 * 5% = 50的算力')}</p>
            </div>
            <div className={totalRate > 100 ? 'is-danger' : ''}>
                <span>{t('当前总比例')}</span>
                <strong>{formatRate(totalRate)}%</strong>
            </div>
        </div>
        <div className="console-invite-levels">
            {rate.map((item, index) => {
                const inputLabel = t('1级返利比例').replace('{index}', index + 1)
                return <div className="console-invite-level" key={`rate-${index}`}>
                    <span className="console-invite-level__number">{index + 1}</span>
                    <div className="console-invite-level__label">
                        <strong>{inputLabel}</strong>
                        <small>{index === 0 ? t('直接下级') : t('间接下级')}</small>
                    </div>
                    <label className="console-invite-percent">
                        <input aria-label={inputLabel} value={item} inputMode="decimal" onChange={(event) => setRate((values) => values.map((value, current) => current === index ? event.target.value : value))} />
                        <span>%</span>
                    </label>
                    {index > 0 && <button type="button" className="console-icon-button is-danger" aria-label={t('删除')} onClick={() => setRate((values) => values.filter((_, current) => current !== index))}><i className="fa fa-trash" /></button>}
                </div>
            })}
        </div>
        <div className="console-invite-toolbar">
            {rate.length < 7 && <button type="button" className="console-button" aria-label={t('新增返利等级')} onClick={() => setRate((value) => [...value, ''])}><i className="fa fa-plus" aria-hidden="true" /> {t('新增返利等级')}</button>}
            <span>{t('已配置等级').replace('{count}', rate.length)}</span>
        </div>
        {errorMsg && <p className="console-form-error" role="alert">{errorMsg}</p>}
    </ConsoleDialog>
}
